import React, {useState} from "react";
import {FormTab, Show, TextInput, TabbedForm, TopToolbar, NumberInput, EditButton, usePermissions} from 'react-admin';
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    parametro: {display: 'inline-block', width: 800, marginLeft: 8},
    parametro_path: {display: 'inline-block', width: 800, marginLeft: 8},
    parametro_descripcion: {display: 'inline-block', width: 800, marginLeft: 8},
}));

const ParametroPathShow = props => {
    const classes = useStyles();
    const { permissions } = usePermissions();
    var w_role_auxiliar_editar = ''
    var w_permissions_admuno_auxiliar_editar = permissions
    if(w_permissions_admuno_auxiliar_editar==null){}else{
        var wa_role_auxiliar_editar = w_permissions_admuno_auxiliar_editar.indexOf('ROLE_AUXILIAR_EDITAR')
        if(wa_role_auxiliar_editar===-1){}else{
            w_role_auxiliar_editar = 'ROLE_AUXILIAR_EDITAR'
        }
    }
    const [Pais, setPais] = useState('');
    const [PersonaTipo, setPersonaTipo] = useState('');
    // const [PaisSocioEstadoCivilCasado, setPaisSocioEstadoCivilCasado] = useState('');

    const establecerPais = value => {
        if (value == null || value === '') return '';
        setPais(value.trim());
        return value;
    };

    const establecerFecha = value => {
        if (value == null || value === '') return '';
        return value;
    };

    // Obtengo tipo de persona para cargar solapa correspondiente
    const establecerPersonaTipo = value => {
        if (value == null || value === '') return '';
        setPersonaTipo(value.trim());
        return value;
    };


    const cuitCuilFormat = value => {
        if (value == null || value === '') return '';

        //normalize string and remove all unnecessary characters
        var valueCuit = value.replace(/[^\d]/g, "");

        //check if number length equals to 11
        if (valueCuit.length == 11) {
            return value.replace(/(\d{2})(\d{8})(\d{1})/, "$1-$2-$3");
        }

        return value
    };

    // const establecerPaisSocioEstadoCivilCasado = value => {
    //     if (value == null || value === '') return '';
    //     setPaisSocioEstadoCivilCasado(value.trim());
    //     return value;
    // };

    const PostEditActions = ({basePath, data, resource}) => (
        <TopToolbar>
            {w_role_auxiliar_editar === 'ROLE_AUXILIAR_EDITAR' &&
                <EditButton basePath={basePath} record={data}/>
            }
        </TopToolbar>
    );

    const PostTitle = ({record}) => {
        return <span>Parametros del Path: {record ? `${record.pais}` : ''}</span>;
    };

    return (
        <Show title={<PostTitle/>} actions={<PostEditActions/>} {...props}>
            <TabbedForm toolbar={false}>
                <FormTab label="DATOS PARAMETRO PATH">

                    <TextInput
                        label="Parametro"
                        source="parametro"
                        formClassName={classes.parametro}
                        placeholder="Ingrese Parametro"
                        helperText="Parametro"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />
                    <br/>

                    <TextInput
                        label="Parametro Path"
                        source="parametro_path"
                        formClassName={classes.parametro_path}
                        placeholder="Ingrese Parametro Path"
                        helperText="Parametro Path"
                        margin="normal"
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />
                    <br/>

                    <TextInput
                        label="Parametro Descripcion"
                        source="parametro_descripcion"
                        formClassName={classes.parametro_descripcion}
                        placeholder="Ingrese Parametro Descripcion"
                        helperText="Parametro Descripcion"
                        margin="normal"
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />
                    <br/>

                </FormTab>
            </TabbedForm>
        </Show>
    )
};
export default ParametroPathShow;


